// extracted by mini-css-extract-plugin
export default {"regionChangeForm":"regionChangeForm-dH4rBN2o","body":"body-mXFFsoWo"};